import ColorCodedDate from './common/ColorCodedDate';
import { BasicEmployee } from './employee';

class OneOnOneCard {
  constructor({
    instanceId,
    parentId,
    coloredDueDate,
    coloredStartDate,
    completionTS,
    instanceState,
    instanceType,
    manager,
    reportee,
    metrics,
    displayManagerTag,
    oneOnOneStatus,
    lastActivity,
  }) {
    this.instanceId = instanceId;
    this.parentId = parentId;
    this.coloredDueDate = coloredDueDate;
    this.coloredStartDate = coloredStartDate;
    this.completionTS = completionTS;
    this.instanceState = instanceState;
    this.instanceType = instanceType;
    this.manager = manager;
    this.reportee = reportee;
    this.metrics = metrics;
    this.displayManagerTag = displayManagerTag;
    this.oneOnOneStatus = oneOnOneStatus;
    this.lastActivity = lastActivity;
  }

  static fromJSON({
    instanceId,
    parentId,
    dueTime,
    startTime,
    completionTS,
    instanceState,
    instanceType,
    manager,
    reportee,
    metrics,
    displayManagerTag,
    oneOnOneStatus,
    lastActivity,
  }) {
    return new OneOnOneCard({
      instanceId,
      instanceState,
      instanceType,
      parentId,
      coloredDueDate: ColorCodedDate.fromJSON(dueTime),
      coloredStartDate: ColorCodedDate.fromJSON(startTime),
      completionTS,

      manager: BasicEmployee.fromJSON(manager),
      reportee: reportee ? BasicEmployee.fromJSON(reportee) : null,
      metrics,
      displayManagerTag,
      oneOnOneStatus,
      lastActivity,
    });
  }
}

export default OneOnOneCard;
